import makePlainAction from '../../../oldpantheon/redux/creators/actions/makePlainAction';

const selectCategory = makePlainAction({
  model: `category`,
  verb: `select`,
});

export default {
  selectCategory,
};
